import { useCallback, useMemo } from 'react'
import { ByWeekday, Weekday } from '@guestgoodie/helpers'

import FilterSelect from '@/components/ui/FilterSelect'
import { useDayOptions } from '../utils/helpers'

export function WeekdaySelect({
  value,
  onChange
}: {
  value?: ByWeekday[] | ByWeekday | null
  onChange: (value: ByWeekday[]) => void
}) {
  const dayOptions = useDayOptions()
  const allDays = useMemo(() => dayOptions.map(day => day.value), [dayOptions])

  const days = useMemo(() => {
    if (!value) return []

    const byweekday = Array.isArray(value) ? value : [value]

    if (byweekday.length === 7) return []

    return byweekday.map(weekday => {
      if (typeof weekday === 'number') return weekday
      if (typeof weekday === 'string') return Weekday.fromStr(weekday).weekday
      return weekday.weekday
    })
  }, [value])

  const onUpdate = useCallback(
    (days: number[]) => {
      if (days.length === 0) onChange(allDays)
      else onChange(days)
    },
    [onChange, allDays]
  )

  return (
    <label className="flex flex-row items-center gap-2">
      <span>An</span>
      <FilterSelect
        options={dayOptions}
        selectedValues={days}
        onChange={onUpdate}
        placeholder="jedem Tag"
      />
    </label>
  )
}
